import { CancelOutlined, CheckCircleOutlineRounded, EditRounded, FileUploadOutlined, MoreVert } from "@mui/icons-material";
import { Box, Button, Dialog, IconButton, Menu, MenuItem, MenuList, Typography } from "@mui/material";
import { grey, lightGreen } from "@mui/material/colors";
import { attributeCollectionTypes } from "components/PimDashboard/data";
import { arrType, createdByColumns, datatypes, inputTypes, publishColumns, selectOptionsKeyName } from "data/globalData";
import { useState } from "react";
import { studioAttrValAssocObj } from "../StudioAttributes/data";

export const lsModalProfileFilterValStr = "modal_profile_table_filter_obj";

const withShootFilterOptions = (row) => {
	if (!row) return row;
	if (row.input_type !== inputTypes.SELECT.key && row.input_type !== inputTypes.MULTIPLE_SELECT.key) return row;

	const linkedValues = row?.[studioAttrValAssocObj];
	const list = Array.isArray(linkedValues)
		? linkedValues.map((val) => ({ name: val?.value, key: val?.value }))
		: (row?.[selectOptionsKeyName]?.list ?? []);

	return {
		...row,
		[selectOptionsKeyName]: { type: arrType, list },
	};
};

export const getShootsFilterColumns = (allAttributes = []) => {
	const map = new Map();
	[
		...(allAttributes || []).filter((row) => row?.collection_type === attributeCollectionTypes.SHOOTS.key),
		...createdByColumns,
		...Object.values(publishColumns),
	].forEach((col) => {
		if (col?.key) map.set(col.key, withShootFilterOptions(col));
	});
	return [...map.values()];
};

export const shootSkuItemMasterColumns = {
	brand: {
		name: "Brand",
		key: "brand",
		bqColumn: "BRAND",
		input_type: inputTypes.SELECT.key,
		constraints: { NOTNULL: false, DISPLAY: true, UNIQUE: false },
		data: {},
		data_type: datatypes.STRING.key,
		sort_no: 1,
		group: "",
		placeholder: "",
		default_value: "",
	},
	sub_brand: {
		name: "Sub Brand",
		key: "sub_brand",
		bqColumn: "SUB_BRAND",
		input_type: inputTypes.SELECT.key,
		constraints: { NOTNULL: false, DISPLAY: true, UNIQUE: false },
		data: {},
		data_type: datatypes.STRING.key,
		sort_no: 1,
		group: "",
		placeholder: "",
		default_value: "",
	},
	division: {
		name: "Division",
		key: "division",
		bqColumn: "DIVISION",
		input_type: inputTypes.SELECT.key,
		constraints: { NOTNULL: false, DISPLAY: true, UNIQUE: false },
		data: {},
		data_type: datatypes.STRING.key,
		sort_no: 1,
		group: "",
		placeholder: "",
		default_value: "",
	},
	season: {
		name: "Season",
		key: "season",
		bqColumn: "SEASON",
		input_type: inputTypes.SELECT.key,
		constraints: { NOTNULL: false, DISPLAY: true, UNIQUE: false },
		data: {},
		data_type: datatypes.STRING.key,
		sort_no: 1,
		group: "",
		placeholder: "",
		default_value: "",
	},
	category: {
		name: "Category",
		key: "category",
		bqColumn: "DEPARTMENT",
		input_type: inputTypes.SELECT.key,
		constraints: { NOTNULL: false, DISPLAY: true, UNIQUE: false },
		data: {},
		data_type: datatypes.STRING.key,
		sort_no: 1,
		group: "",
		placeholder: "",
		default_value: "",
	},
	sub_category: {
		name: "Sub Category",
		key: "sub_category",
		bqColumn: "PATTERN",
		input_type: inputTypes.SELECT.key,
		constraints: { NOTNULL: false, DISPLAY: true, UNIQUE: false },
		data: {},
		data_type: datatypes.STRING.key,
		sort_no: 1,
		group: "",
		placeholder: "",
		default_value: "",
	},
	style_name: {
		name: "Style Name",
		key: "style_name",
		bqColumn: "STYLE",
		input_type: inputTypes.SELECT.key,
		constraints: { NOTNULL: false, DISPLAY: true, UNIQUE: false },
		data: {},
		data_type: datatypes.STRING.key,
		sort_no: 1,
		group: "",
		placeholder: "",
		default_value: "",
	},
	color: {
		name: "Color",
		key: "color",
		bqColumn: "COLOR",
		input_type: inputTypes.SELECT.key,
		constraints: { NOTNULL: false, DISPLAY: true, UNIQUE: false },
		data: {},
		data_type: datatypes.STRING.key,
		sort_no: 1,
		group: "",
		placeholder: "",
		default_value: "",
	},
	pallete: {
		name: "Pallete",
		key: "pallete",
		bqColumn: "COLOR",
		input_type: inputTypes.SELECT.key,
		constraints: { NOTNULL: false, DISPLAY: true, UNIQUE: false },
		data: {},
		data_type: datatypes.STRING.key,
		sort_no: 1,
		group: "",
		placeholder: "",
		default_value: "",
	},
	size: {
		name: "Size",
		key: "size",
		bqColumn: "SIZE",
		input_type: inputTypes.SELECT.key,
		constraints: { NOTNULL: false, DISPLAY: true, UNIQUE: false },
		data: {},
		data_type: datatypes.STRING.key,
		sort_no: 1,
		group: "",
		placeholder: "",
		default_value: "",
	},
	fashionability: {
		name: "Fashionability",
		key: "fashionability",
		bqColumn: "FASHIONABILITY",
		input_type: inputTypes.SELECT.key,
		constraints: { NOTNULL: false, DISPLAY: true, UNIQUE: false },
		data: {},
		data_type: datatypes.STRING.key,
		sort_no: 1,
		group: "",
		placeholder: "",
		default_value: "",
	},
};
export const shootMerchantSampleDetailsColumns = {
	planned_sample_date: {
		name: "Planned Sample Handover",
		key: "planned_sample_date",
		input_type: inputTypes.ENTER.key,
		constraints: { NOTNULL: false, DISPLAY: true, UNIQUE: false },
		data: {},
		data_type: datatypes.DATE.key,
		sort_no: 1,
		group: "",
		placeholder: "",
		default_value: "",
	},
	sample_ready_date: {
		name: "Sample Ready Date",
		key: "sample_ready_date",
		input_type: inputTypes.AUTO_GENERATE.key,
		constraints: { NOTNULL: false, DISPLAY: true, UNIQUE: false },
		data: {},
		data_type: datatypes.DATE.key,
		sort_no: 2,
		group: "",
		placeholder: "",
		default_value: "",
	},
	expected_production_inward: {
		name: "Expected Production Inward",
		key: "expected_production_inward",
		bqColumn: "DIVISION",
		input_type: inputTypes.ENTER.key,
		constraints: { NOTNULL: false, DISPLAY: true, UNIQUE: false },
		data: {},
		data_type: datatypes.DATE.key,
		sort_no: 1,
		group: "",
		placeholder: "",
		default_value: "",
	},
	vendor_name: {
		name: "Vendor Name",
		key: "vendor_name",
		input_type: inputTypes.ENTER.key,
		constraints: { NOTNULL: false, DISPLAY: true, UNIQUE: false },
		data: {},
		data_type: datatypes.STRING.key,
		sort_no: 1,
		group: "",
		placeholder: "",
		default_value: "",
	},
	cost: {
		name: "Cost",
		key: "cost",
		input_type: inputTypes.ENTER.key,
		constraints: { NOTNULL: false, DISPLAY: true, UNIQUE: false },
		data: {},
		data_type: datatypes.DECIMAL.key,
		sort_no: 1,
		group: "",
		placeholder: "",
		default_value: "",
	},
	merchant_remarks: {
		name: "Merchant Remarks",
		key: "merchant_remarks",
		input_type: inputTypes.ENTER.key,
		constraints: { NOTNULL: false, DISPLAY: true, UNIQUE: false },
		data: {},
		data_type: datatypes.STRING.key,
		sort_no: 1,
		group: "",
		placeholder: "",
		default_value: "",
	},
};

export const merchantUpdatedByColumn = {
	name: "Merchant Updated By",
	key: "merchant_updated_by",
	input_type: inputTypes.AUTO_GENERATE.key,
	constraints: { NOTNULL: false, DISPLAY: true, UNIQUE: false },
	data: {},
	data_type: datatypes.STRING.key,
	sort_no: 99,
	group: "",
	placeholder: "",
	default_value: "",
};

export const shootSkuIcodeColumn = {
	name: "ICODE",
	key: "i_code",
	bqColumn: "ICODE",
	input_type: inputTypes.ENTER.key,
	constraints: { NOTNULL: false, DISPLAY: true, UNIQUE: false },
	data: {},
	data_type: datatypes.STRING.key,
	sort_no: 1,
	group: "",
	placeholder: "",
};
export const shootMerchantSampleImgUrlCol = {
	name: "Sample Handover Image",
	key: "handover_img_url",
	input_type: inputTypes.ENTER.key,
	constraints: { NOTNULL: false, DISPLAY: true, UNIQUE: false },
	data: {},
	data_type: datatypes.STRING.key,
	sort_no: 1,
	group: "",
	placeholder: "",
};
export const shootStudioSampleImgUrlCol = {
	name: "Sample Inward Image",
	key: "inward_img_url",
	input_type: inputTypes.ENTER.key,
	constraints: { NOTNULL: false, DISPLAY: true, UNIQUE: false },
	data: {},
	data_type: datatypes.STRING.key,
	sort_no: 1,
	group: "",
	placeholder: "",
};

export const hasSampleGrnImage = (valueOrRow) => {
	const url = typeof valueOrRow === "object" && valueOrRow !== null ? valueOrRow.grn_img_url : valueOrRow;
	return Boolean(`${url ?? ""}`.trim());
};

const GrnUploadedChip = ({ row }) => {
	const uploaded = hasSampleGrnImage(row);
	return (
		<Box display="flex" width="100%" height="100%" alignItems="center" justifyContent="center">
			<Box
				display="flex"
				width="fit-content"
				alignItems="center"
				height="22px"
				sx={{
					backgroundColor: uploaded ? lightGreen.A700 : grey[400],
					color: "white",
					padding: "6px",
					borderRadius: "5px",
				}}>
				{uploaded ? <CheckCircleOutlineRounded fontSize="small" /> : <CancelOutlined fontSize="small" />}
				<Typography pl="3px" fontSize={14}>
					{uploaded ? "YES" : "NO"}
				</Typography>
			</Box>
		</Box>
	);
};

const GrnImageThumb = ({ url, onClick }) => (
	<Box
		component="img"
		src={url}
		alt="GRN"
		onClick={onClick}
		sx={{
			height: 40,
			width: 28,
			objectFit: "cover",
			borderRadius: 1,
			display: "block",
			cursor: "pointer",
			border: `1px solid ${grey[300]}`,
			flexShrink: 0,
		}}
	/>
);

const GrnImageActionCell = ({ row, url, disableUpload, onAction }) => {
	const imageUrl = typeof url === "object" && url !== null ? url.grn_img_url : url;
	const uploaded = hasSampleGrnImage(imageUrl);
	const [previewOpen, setPreviewOpen] = useState(false);

	if (!uploaded && disableUpload) {
		return (
			<Box width="100%" height="100%" display="flex" alignItems="center" justifyContent="center">
				<Typography variant="body2" color="text.secondary">
					—
				</Typography>
			</Box>
		);
	}

	if (!uploaded) {
		return (
			<Box
				width="100%"
				height="100%"
				display="flex"
				alignItems="center"
				justifyContent="center"
				onClick={(e) => e.stopPropagation()}>
				<Button
					size="small"
					disableElevation
					variant="contained"
					startIcon={<FileUploadOutlined fontSize="small" />}
					sx={{ textTransform: "none", borderRadius: 1.5, minWidth: 76, px: 1.5, fontWeight: 600 }}
					onClick={(e) => {
						e.stopPropagation();
						onAction?.(row);
					}}>
					Upload
				</Button>
			</Box>
		);
	}

	return (
		<>
			<Box
				width="100%"
				height="100%"
				display="flex"
				alignItems="center"
				justifyContent="center"
				gap={0.5}
				onClick={(e) => e.stopPropagation()}>
				<GrnImageThumb
					url={imageUrl}
					onClick={(e) => {
						e.stopPropagation();
						setPreviewOpen(true);
					}}
				/>
				{!disableUpload && (
					<IconButton
						size="small"
						onClick={(e) => {
							e.stopPropagation();
							onAction?.(row);
						}}>
						<EditRounded fontSize="small" />
					</IconButton>
				)}
			</Box>
			<Dialog open={previewOpen} onClose={() => setPreviewOpen(false)} onClick={(e) => e.stopPropagation()} maxWidth="md">
				<img src={imageUrl} alt="GRN preview" style={{ maxWidth: "90vw", maxHeight: "80vh", display: "block" }} />
			</Dialog>
		</>
	);
};

const GrnImagePreviewCell = ({ url }) => {
	const [open, setOpen] = useState(false);
	const imageUrl = typeof url === "object" && url !== null ? url.grn_img_url : url;

	if (!hasSampleGrnImage(imageUrl)) {
		return (
			<Box width="100%" height="100%" display="flex" alignItems="center" justifyContent="center">
				<Typography variant="body2" color="text.secondary">
					—
				</Typography>
			</Box>
		);
	}

	return (
		<>
			<Box
				width="100%"
				height="100%"
				display="flex"
				alignItems="center"
				justifyContent="center"
				onClick={(e) => {
					e.stopPropagation();
					setOpen(true);
				}}>
				<GrnImageThumb url={imageUrl} />
			</Box>
			<Dialog open={open} onClose={() => setOpen(false)} onClick={(e) => e.stopPropagation()} maxWidth="md">
				<img src={imageUrl} alt="GRN preview" style={{ maxWidth: "90vw", maxHeight: "80vh", display: "block" }} />
			</Dialog>
		</>
	);
};

export const shootStudioSampleGrnUploadedCol = {
	name: "GRN Uploaded",
	key: "grn_uploaded",
	input_type: inputTypes.AUTO_GENERATE.key,
	constraints: { NOTNULL: false, DISPLAY: true, UNIQUE: false },
	data: {},
	data_type: datatypes.STRING.key,
	sort_no: 1,
	group: "",
	placeholder: "",
	minWidth: 120,
	valueGetter: ({ row }) => (hasSampleGrnImage(row) ? "YES" : "NO"),
	renderCell: ({ row }) => <GrnUploadedChip row={row} />,
};

export const shootStudioSampleGrnImgUrlCol = {
	name: "GRN Image",
	key: "grn_img_url",
	input_type: inputTypes.ENTER.key,
	constraints: { NOTNULL: false, DISPLAY: true, UNIQUE: false },
	data: {},
	data_type: datatypes.STRING.key,
	sort_no: 1,
	group: "",
	placeholder: "",
	minWidth: 140,
	renderCell: ({ value, row }) => <GrnImagePreviewCell url={value || row?.grn_img_url} />,
};

export const getShootStudioSampleGrnImgUrlCol = ({ onAction, disableUpload = false, canUpload } = {}) => ({
	...shootStudioSampleGrnImgUrlCol,
	minWidth: 170,
	renderCell: ({ value, row }) => (
		<GrnImageActionCell
			row={row}
			url={value || row?.grn_img_url}
			disableUpload={disableUpload || (typeof canUpload === "function" && !canUpload(row))}
			onAction={onAction}
		/>
	),
});

export const shootStudioSampleDetailsColumns = {
	sample_inward_date: {
		name: "Sample Inward Date",
		key: "sample_inward_date",
		input_type: inputTypes.AUTO_GENERATE.key,
		constraints: { NOTNULL: false, DISPLAY: true, UNIQUE: false },
		data: {},
		data_type: datatypes.DATE.key,
		sort_no: 1,
		group: "",
		placeholder: "",
	},

	ginesys_code: {
		name: "Ginesys Code",
		key: "ginesys_code",
		input_type: inputTypes.ENTER.key,
		constraints: { NOTNULL: false, DISPLAY: true, UNIQUE: false },
		data: {},
		data_type: datatypes.STRING.key,
		sort_no: 1,
		group: "",
		placeholder: "",
	},
	studio_remarks: {
		name: "Studio Remarks",
		key: "studio_remarks",
		input_type: inputTypes.ENTER.key,
		constraints: { NOTNULL: false, DISPLAY: true, UNIQUE: false },
		data: {},
		data_type: datatypes.STRING.key,
		sort_no: 1,
		group: "",
		placeholder: "",
	},
};

export const studioUpdatedByColumn = {
	name: "Studio Updated By",
	key: "studio_updated_by",
	input_type: inputTypes.AUTO_GENERATE.key,
	constraints: { NOTNULL: false, DISPLAY: true, UNIQUE: false },
	data: {},
	data_type: datatypes.STRING.key,
	sort_no: 99,
	group: "",
	placeholder: "",
	default_value: "",
};

export const sampleStatusColumn = {
	name: "Status",
	key: "status",
	input_type: inputTypes.AUTO_GENERATE.key,
	constraints: { NOTNULL: false, DISPLAY: true, UNIQUE: false },
	data: {},
	data_type: datatypes.STRING.key,
	sort_no: 1,
	group: "",
	placeholder: "",
	default_value: "",
};

const ActionCell = ({ row, actionList }) => {
	const [anchorEl, setAnchorEl] = useState(null);

	const handleOpen = (e) => {
		setAnchorEl(e.currentTarget);
		e.stopPropagation();
	};
	const handleClose = () => setAnchorEl(null);

	return (
		<>
			<IconButton onClick={handleOpen}>
				<MoreVert />
			</IconButton>

			<Menu anchorEl={anchorEl} open={Boolean(anchorEl)} onClose={handleClose}>
				{actionList.map((action) => (
					<MenuItem
						key={action.name}
						onClick={(e) => {
							e.stopPropagation();
							action.onClick(row);
							handleClose();
						}}>
						{action.name}
					</MenuItem>
				))}
			</Menu>
		</>
	);
};

export const shootSkuActionDgCol = (actionList) => {
	return {
		headerName: "Actions",
		minWidth: 80,
		headerAlign: "center",
		align: "center",
		flex: 1,
		renderCell: (params) => {
			return (
				<Box width="100%" display="flex" alignItems="center" justifyContent="center">
					<ActionCell row={params.row} actionList={actionList} />
				</Box>
			);
		},
	};
};
